import { CategoryTreeItem, Product, ProductPromotion } from '../product';

export enum ConnectedUsersStatusEnum {
  STOPPED = 'STOPPED',
  SCAN_QR_CODE = ' SCAN_QR_CODE ',
  STARTING = 'STARTING',
  WORKING = 'WORKING',
  FAILED = 'FAILED',
  active = 'active',
}

export enum TemplateComponentTypeEnum {
  header = 'HEADER',
  body = 'BODY',
  carousel = 'CAROUSEL',
  buttons = 'BUTTONS',
  image = 'IMAGE',
  reject = 'REJECTED',
}

export interface CampaignsRequest {
  workspaceId: string;
  params: {
    sellerWorkspaceId: string;
  };
}
export interface CampaignDetailsRequest {
  workspaceId: string;
  campaignId: string;
  params: {
    customerId?: string;
    sellerWorkspaceId: string;
  };
}

export interface CampaignDetailsV2Request {
  workspaceId: string;
  params: {
    campaignId: string;
    customerId?: string;
    sellerWorkspaceId: string;
    includeProducts?: boolean;
  };
}

export interface CampaignDetailsResponse {
  data: CampaignDetailsData;
  message: string;
  statusCode: number;
}

export interface CampaignDetailsData {
  id: string;
  createdDate: string;
  updatedDate: string;
  code: string;
  name: string;
  description: string;
  type: string;
  channelId: number;
  productVariants: CampaignDetailsProductVariant[];
  assets: CampaignDetailsAsset[];
}

export interface CampaignDetailsProductVariant {
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  enabled: boolean;
  isDeleted: boolean;
  ZINS: boolean;
  sku: string;
  sortOrder: number;
  stockOnHand: number;
  stockAllocated: number;
  outOfStockThreshold: number;
  useGlobalOutOfStockThreshold: boolean;
  trackInventory: string;
  id: number;
  taxCategoryId: number;
  productId: number;
  productVariantAttribute: CampaignDetailsProductVariantAttribute;
  productVariantPrices: CampaignDetailsProductVariantPrice[];
  translations: CampaignDetailsTranslation[];
  price: number;
  priceWithTax: number;
  promotions?: ProductPromotion[];
}

export interface CampaignDetailsProductVariantAttribute {
  id: string;
  createdDate: string;
  updatedDate: string;
  productVariantId: number;
  ean: string;
  erpId: string;
  vairantCode: any;
  erpUOM: string;
  packingInfo: any;
  hsnCode: string;
  upcCode: string;
  baseUom: string;
  warrentyInformation: string;
  condition: string;
  packSize: number;
  minOrderQty: number;
  maxOrderQty: number;
  quantity: number;
  qtyMultiplier: number;
  grossWeight: any;
  netWeight: any;
  volume: any;
  MRP: number;
  PTR: number;
  caseSize: any;
  minRemShelfLife: number;
  erpPriceUOM: string;
  isSpecial: any;
  mfgCode: any;
  mfgName: any;
  weightUOM: any;
  volumeUOM: any;
  launchDate: any;
  manufacturingDate: any;
  expiryDate: any;
  bestBeforeOrAfter: any;
  popularity: number;
  bestAfter: any;
  salesOrg: any;
}

export interface CampaignDetailsProductVariantPrice {
  createdAt: string;
  updatedAt: string;
  price: number;
  id: number;
  channelId: number;
}

export interface CampaignDetailsTranslation {
  createdAt: string;
  updatedAt: string;
  languageCode: string;
  name: string;
  shortName: string;
  shortDescription: string;
  id: number;
}

export interface CampaignDetailsAsset {
  createdAt: string;
  updatedAt: string;
  name: string;
  type: string;
  mimeType: string;
  width: number;
  height: number;
  fileSize: number;
  source: string;
  preview: string;
  focalPoint: CampaignDetailsFocalPoint;
  id: number;
}

export interface CampaignDetailsFocalPoint {
  x: number;
  y: number;
}

export interface CampaignDetailsV2Response {
  statusCode: number;
  message: string;
  data: CampaignDetailsV2Data;
}

export interface CampaignDetailsV2Data {
  campaignName: string;
  type: string;
  createdDate: string;
  id: string;
  productVariants: CampaignDetailsV2ProductVariant[];
  startRecord: number;
  endRecord: number;
  total: number;
}

export interface CampaignDetailsV2ProductVariant {
  parentSku: string;
  productAsset: CampaignDetailsV2ProductAsset;
  source: string;
  preview: string;
  enabled: boolean;
  id: number;
  productVariants: CampaignDetailsV2ProductVariant2[];
  channelId: number;
  workspaceId: string;
}

export interface CampaignDetailsV2ProductAsset {}

export interface CampaignDetailsV2ProductVariant2 {
  facets: any[];
  assets: {
    filename: string;
    redirectUrl: string;
    sequenceNo: number;
    subType: string;
  }[];
  taxCategory: CampaignDetailsV2TaxCategory;
  enabled: boolean;
  price: number;
  MRP: number;
  PTR: number;
  isSpecial: any;
  sku: string;
  sortOrder: number;
  id: number;
  taxCategoryId: number;
  productId: number;
  name: string;
  shortName: string;
  shortDescription: string;
  categories: CampaignDetailsV2Category[];
  productVariantId: number;
  ean: string;
  erpId: string;
  erpPriceUOM: string;
  erpUOM: string;
  ZINS: boolean;
  hsnCode: string;
  upcCode: string;
  baseUom: string;
  quantity: number;
  warrentyInformation: string;
  condition: string;
  packSize: number;
  manufacturingDate: any;
  expiryDate: any;
  bestBeforeOrAfter: any;
  popularity: number;
  bestAfter: any;
  minOrderQty: number;
  maxOrderQty: number;
  minRemShelfLife: number;
  qtyMultiplier: number;
  grossWeight: any;
  netWeight: any;
  volume: any;
  division: CampaignDetailsV2Division[];
  cfas: CampaignDetailsV2Cfa[];
  collections: any[];
  promotions: ProductPromotion[];
  stock: number;
  sales: number;
  margin: string;
  isActiveForOrderCfaIds: string[];
  salesOrg: any;
}

export interface CampaignDetailsV2TaxCategory {
  id: number;
  name: string;
}

export interface CampaignDetailsV2Category {
  categoryId: number;
  categoryName: string;
  categoryCode: string;
}

export interface CampaignDetailsV2Division {
  divisionCode: string;
  divisionId: string;
  name: string;
  headDivisionId: string;
  headDivision: CampaignDetailsV2HeadDivision;
  isDefault: boolean;
}

export interface CampaignDetailsV2HeadDivision {
  id: string;
  code: string;
  name: string;
}

export interface CampaignDetailsV2Cfa {
  cfaCode: string;
  cfaId: string;
  supplierName: string;
  isDefault: boolean;
  minOrderQty: number;
}

export interface CampaignProductsRequest {
  campaignId: string;
  sellerWorkspaceId: string;
  customerId?: string;
  workspaceId: string;
  searchKey?: string;
  divisionIds?: string[];
  categoryCodes?: string[];
  pageNo?: number;
  pageSize?: number;
  campaignType?: string;
  includeCategoryTreeList?: boolean;
  productVariantIds?: number[];
  groupByProduct?: boolean;
}

export interface CampaignProductsResponse {
  statusCode: number;
  message: string;
  data: CampaignProduct;
}

export interface CampaignProduct {
  total: number;
  startRecord: number;
  endRecord: number;
  products: Product[];
  categoryCodes: {
    categoryName: string;
    categoryCode: string;
    categoryId: string;
  }[];
  categoryTree?: CategoryTreeItem[];
  divisionSummary: {
    divisionCode: string;
    divisionId: string;
    name: string;
    headDivisionId: string;
    headDivision: {
      id: string;
      code: string;
      name: string;
    };
    isDefault: boolean;
  }[];
  cfaSummary: {
    cfaCode: string;
    cfaId: string;
    supplierName: string;
    isDefault: boolean;
  }[];
  status: string;
  statusCode: number;
}

export interface TemplateListRequest {
  wabaId?: string;
  platformFlag?: boolean;
  sellerWorkSpaceId: string;
  pageNo: number;
  pageSize: number;
  filters: {
    MetaTag: string;
  };
  searchKey?: string;
}

export interface TemplateListResponse {
  id: string;
  createdDate: string;
  updatedDate: string;
  workspaceId: string;
  wabaId: string;
  whatsappPhoneNoId: string | null;
  whatsappPhoneNo: string;
  namespaceId: string | null;
  userToken: string;
  metaBusinessToken: string;
  provider: string;
  sid: null;
  qualityRating: string | null;
  messageLimit: number | null;
  isDefault: boolean;
  isShared: boolean;
  active: boolean;
  isDeleted: boolean;
  deletedAt: null;
  status: ConnectedUsersStatusEnum;
  displayName: string;
  authCode: null;
  profilePic: null;
  projectId: string;
  isCoexistence: boolean;
  branch: string;
  tag: string;
  esLinkID: null;
  info: null;
  isCatalogueSyncEnable: boolean;
  fbmId: string;
  wabaTemplates: EachWabaTemplatesRes[];
  refreshedQualityRating: any;
  refreshedMessageLimit: any;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    startRecord: number;
    endRecord: number;
  };
}

export interface EachWabaTemplatesRes {
  id: string;
  createdDate: string;
  updatedDate: string;
  wabaId: string;
  category: string;
  whatsappConfigId: string;
  templateId: string;
  templateName: string;
  status: string;
  health: string;
  branch: string;
  tag: string;
  language: string;
  action: string;
  isCustomized: boolean;
  templateBody: TemplateBodyRes;
  templateDetails: TemplateDetailsRes;
  uploadStatusMessage: string;
}

export interface TemplateBodyRes {
  name: string;
  category: string;
  components: TemplateDetailsBodyComponent[];
  language: string;
}

export interface TemplateDetailsRes {
  name: string;
  parameter_format: string;
  components: TemplateDetailsBodyComponent[];
  language: string;
  status: string;
  category: string;
  id: string;
}

export interface TemplateDetailsBodyComponent {
  type: string;
  text?: string;
  format?: string;
  example?: TemplateExample;
  cards?: TemplateDetailsCard[];
}

export interface TemplateDetailsCard {
  components: TemplateComponent[];
}

export interface TemplateComponent {
  type: string;
  format?: string;
  example?: TemplateExample;
  text?: string;
  buttons?: ComponentButton[];
}

export interface TemplateExample {
  header_handle?: string[];
  body_text?: string[][];
}

export interface ComponentButton {
  type: string;
  text: string;
  url?: string;
  example?: string[];
}
